import React from 'react';

const SvgIcDocument = props => (
  <svg
    id="prefix__img_document"
    width={props.size || 39.896}
    height={props.size || 50.931}
    viewBox="0 0 39.896 50.931"
    xmlSpace="preserve"
    fill="#104eb2"
    {...props}
  >
    <defs></defs>
    <g id="ic_contract_svg__document" transform="translate(-6.5)">
      <path
        id="ic_contract_svg__Path_423"
        d="M34.014 0H6.5v50.931h39.9v-38.55zm.5 2.9l8.986 8.984h-8.988zM8.2 49.233V1.7h24.614v11.881H44.7v35.652z"
        className="ic_contract_svg__cls-1"
        data-name="Path 423"
      />
      <path
        id="ic_contract_svg__Path_424"
        d="M16.349 16.7h7.64a.849.849 0 100-1.7h-7.64a.849.849 0 100 1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 424"
        transform="translate(-1.36 -2.267)"
      />
      <path
        id="ic_contract_svg__Path_425"
        d="M30.779 37h-14.43a.849.849 0 000 1.7h14.43a.849.849 0 000-1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 425"
        transform="translate(-1.36 -5.593)"
      />
      <path
        id="ic_contract_svg__Path_426"
        d="M42.291 30h-5.942a.849.849 0 000 1.7h5.942a.849.849 0 000-1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 426"
        transform="translate(-4.384 -4.535)"
      />
      <path
        id="ic_contract_svg__Path_427"
        d="M16.349 24.7h4.244a.849.849 0 000-1.7h-4.244a.849.849 0 000 1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 427"
        transform="translate(-1.36 -3.477)"
      />
      <path
        id="ic_contract_svg__Path_428"
        d="M31.349 24.7h5.942a.849.849 0 000-1.7h-5.942a.849.849 0 000 1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 428"
        transform="translate(-3.628 -3.477)"
      />
      <path
        id="ic_contract_svg__Path_429"
        d="M25.5 23.851a.849.849 0 10.246-.6.893.893 0 00-.246.6z"
        className="ic_contract_svg__cls-1"
        data-name="Path 429"
        transform="translate(-2.872 -3.479)"
      />
      <path
        id="ic_contract_svg__Path_430"
        d="M21.349 30a.849.849 0 100 1.7h8.488a.849.849 0 100-1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 430"
        transform="translate(-2.116 -4.535)"
      />
      <path
        id="ic_contract_svg__Path_431"
        d="M16.349 31.7a.851.851 0 10-.6-1.452.873.873 0 00-.246.6.841.841 0 00.849.849z"
        className="ic_contract_svg__cls-1"
        data-name="Path 431"
        transform="translate(-1.36 -4.537)"
      />
      <path
        id="ic_contract_svg__Path_432"
        d="M42.291 44h-5.942a.849.849 0 000 1.7h5.942a.849.849 0 000-1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 432"
        transform="translate(-4.384 -6.651)"
      />
      <path
        id="ic_contract_svg__Path_433"
        d="M29.837 44h-8.488a.849.849 0 000 1.7h8.488a.849.849 0 100-1.7z"
        className="ic_contract_svg__cls-1"
        data-name="Path 433"
        transform="translate(-2.116 -6.651)"
      />
      <path
        id="ic_contract_svg__Path_434"
        d="M15.746 44.248a.86.86 0 00-.246.6.84.84 0 00.246.6.893.893 0 00.6.246.877.877 0 00.6-.246.893.893 0 00.246-.6.838.838 0 00-.246-.594.88.88 0 00-1.2-.006z"
        className="ic_contract_svg__cls-1"
        data-name="Path 434"
        transform="translate(-1.36 -6.653)"
      />
      <path
        id="ic_contract_svg__Path_435"
        d="M42.746 23.248a.852.852 0 001.205 1.205.861.861 0 000-1.205.889.889 0 00-1.205 0z"
        className="ic_contract_svg__cls-1"
        data-name="Path 435"
        transform="translate(-5.442 -3.479)"
      />
      <path
        id="ic_contract_svg__Path_436"
        d="M38.952 38.453a.849.849 0 10-1.205 0 .844.844 0 00.6.246.877.877 0 00.605-.246z"
        className="ic_contract_svg__cls-1"
        data-name="Path 436"
        transform="translate(-4.686 -5.595)"
      />
      <path
        id="ic_contract_svg__Path_437"
        d="M42.746 37.248a.861.861 0 000 1.205.861.861 0 001.205 0 .852.852 0 00-1.205-1.205z"
        className="ic_contract_svg__cls-1"
        data-name="Path 437"
        transform="translate(-5.442 -5.595)"
      />
    </g>
  </svg>
);

export default SvgIcDocument;
